import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    assignPoint,
} from "./api";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { setCurrentAssignments } from "./reducer";
import { refreshToken } from "../../api/api";
import { setAuthorization } from "../../api/httpClient";

// Helper para decodificar el token JWT de forma segura (mismo patrón usado en AuthProtected)
const decodeJwtPayload = (token: string) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch {
        return null;
    }
};

// Hidratar asignación actual desde el token
export const hydrateAssignmentsFromToken = createAsyncThunk(
    "assignments/hydrateFromToken",
    async (_: void, { dispatch }) => {
        const authUser = localStorage.getItem("authUser");
        const token = authUser ? (() => { try { return JSON.parse(authUser).token as string | null; } catch { return null; } })() : null;
        if (!token) return;

        const payload = decodeJwtPayload(token) || {};

        const establishmentId = (
            payload.establishmentId ||
            payload.currentEstablishmentId ||
            payload.establishment?.id ||
            payload.assignment?.establishmentId ||
            null
        );

        const pointId = (
            payload.pointId ||
            payload.currentPointId ||
            payload.point?.id ||
            payload.assignment?.pointId ||
            payload.emissionPointId ||
            payload.currentEmissionPointId ||
            payload.emissionPoint?.id ||
            payload.assignment?.emissionPointId ||
            null
        );

        dispatch(setCurrentAssignments({
            establishmentId: establishmentId != null ? String(establishmentId) : undefined,
            pointId: pointId != null ? String(pointId) : undefined,
        }));
    }
);

export const assignPointThunk = createAsyncThunk("assignments/assignPoint", async ({ establishmentId, emissionPointId }: { establishmentId: string; emissionPointId: string }, { rejectWithValue, dispatch }) => {
    try {
        const response = await assignPoint(establishmentId, emissionPointId);

        dispatch(setCurrentAssignments({
            establishmentId: String(establishmentId),
            pointId: String(emissionPointId)
        }));

        const authUser = localStorage.getItem("authUser");
        if (authUser) {
            try {
                const user = JSON.parse(authUser);
                if (user.token) {
                    const refreshResponse = await refreshToken();
                    
                    if (refreshResponse && refreshResponse.token) {
                        const newToken = refreshResponse.token;

                        user.token = newToken;
                        localStorage.setItem("authUser", JSON.stringify(user));

                        setAuthorization(newToken);
                        
                        console.log("Token actualizado correctamente");
                    } else {
                        console.warn("No se recibió un nuevo token del endpoint de refresh");
                    }
                }
            } catch (tokenError) {
                console.warn("No se pudo actualizar el token:", tokenError);
            }
        }
        
        toast.success("Punto de emisión asignado correctamente", { autoClose: 3000 });
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al asignar el punto de emisión";
        toast.error(message, { autoClose: 3000 });
        return rejectWithValue(message);
    }
});
